module.exports = __webpack_public_path__ + "static/media/delivery@2x.252b1554.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_120/imgs/delivery@2x.png
// module id = 1133
// module chunks = 0